import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#7C3AED",
      dark: "#6D28D9",
    },
    text: {
      primary: "#111827",
      secondary: "#4B5563",
    },
    background: {
      default: "#F0F4FF",
      paper: "#F9FCFB",
    },
    divider: "#D1D5DB",
  },
  typography: {
    fontFamily: "Poppins, sans-serif",
    fontSize: 16,
    letterSpacing: "0.015em",
    h1: {
      fontWeight: 700,
      fontSize: "3.5rem",
      lineHeight: 1.2,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontWeight: 700,
      fontSize: "2.5rem",
      lineHeight: 1.3,
      letterSpacing: "-0.01em",
    },
    h4: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.5,
      letterSpacing: "-0.005em",
    },
    h5: {
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.5,
      letterSpacing: "0",
    },
    body1: {
      letterSpacing: "0.01em",
      lineHeight: 1.6,
    },
    body2: {
      letterSpacing: "0.01em",
      lineHeight: 1.6,
    },
    button: {
      letterSpacing: "0.02em",
      fontWeight: 600,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 6,
            "& fieldset": {
              borderColor: "rgba(0, 0, 0, 0.15)",
            },
            "&:hover fieldset": {
              borderColor: "rgba(124, 58, 237, 0.5)",
            },
            "& input::placeholder": {
              fontSize: "0.875rem",
              opacity: 0.7,
            },
          },
          "& input": {
            fontSize: "0.875rem",
          },
          "& textarea": {
            fontSize: "0.875rem",
          },
          "& textarea::placeholder": {
            fontSize: "0.875rem",
            opacity: 0.7,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 6,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontSize: "0.875rem",
          "& .MuiSelect-select": {
            padding: "8.5px 14px",
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          color: "#000000",
          "& .MuiSlider-thumb": {
            backgroundColor: "#000000",
            "&:hover, &.Mui-focusVisible": {
              boxShadow: "0 0 0 8px rgba(0, 0, 0, 0.1)",
            },
          },
          "& .MuiSlider-track": {
            backgroundColor: "#000000",
          },
          "& .MuiSlider-rail": {
            backgroundColor: "#E0E0E0",
          },
          "& .MuiSlider-valueLabel": {
            fontSize: "0.75rem",
            backgroundColor: "#000000",
          },
          "& .MuiSlider-mark": {
            backgroundColor: "#000000",
          },
        },
      },
    },
  },
});

export default theme;
